import { useState, useEffect } from 'react';
import { getProductImage } from '../../utils/imageStorage';
import LocalImageUploader from '../../components/feature/LocalImageUploader';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useCart } from '../../hooks/useCart';

export default function ProduitLot2SapinsNoelLivrePlie() {
  const { addToCart } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const productId = 'lot-2-sapins-noel-livre-plie';
  const defaultImage = 'https://public.readdy.ai/ai/img_res/50e7322050a0e1f6476bda3e1095fde5.jpg';
  const [productImage, setProductImage] = useState<string>(defaultImage);
  const [showImageUploader, setShowImageUploader] = useState(false);

  const product = {
    id: 'lot-2-sapins-noel',
    name: 'Lot de 2 Sapins de Noël en livre plié – duo poétique 🎁',
    price: 22,
    description: 'Deux petits arbres nés de papier pour illuminer vos fêtes'
  };

  const productImages = [
    'https://readdy.ai/api/search-image?query=Two handmade Christmas trees made from folded book pages, centered perfectly on soft pink powder background #F3D9D9, square format 1080x1080px, artisanal paper craft decorations with white lace ribbon and pearl decorations, vintage book pages carefully folded into tree shapes, warm natural studio lighting, no shadows, clean minimalist composition, elegant handmade ornaments, delicate craftsmanship, product photography style&width=1080&height=1080&seq=lot-2-sapins-produit1&orientation=squarish',
    'https://readdy.ai/api/search-image?query=Close-up of two different handmade Christmas trees made from folded book pages, showing intricate paper folding technique, centered perfectly on soft pink powder background #F3D9D9, square format 1080x1080px, white lace and ribbon details, vintage book pages texture, artisanal Christmas craft duo, warm natural studio lighting, no shadows, clean minimalist composition, delicate handwork, product photography style&width=1080&height=1080&seq=lot-2-sapins-produit2&orientation=squarish',
    'https://readdy.ai/api/search-image?query=Two handmade Christmas trees made from folded book pages on festive table setting, centered perfectly on soft pink powder background #F3D9D9, square format 1080x1080px, various ribbons and lace decorations, vintage book pages folded into tree shapes, warm natural studio lighting, no shadows, clean minimalist composition, elegant handmade ornaments, delicate craftsmanship, product photography style&width=1080&height=1080&seq=lot-2-sapins-produit3&orientation=squarish'
  ];
  const [mainImage, setMainImage] = useState(productImages[0]);

  const handleAddToCart = () => {
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      image: mainImage,
      description: product.description,
      link: '/produit-lot-2-sapins-noel-livre-plie'
    }, quantity);
    
    // Feedback visuel
    const button = document.querySelector('.add-to-cart-btn') as HTMLButtonElement;
    if (button) {
      const originalText = button.innerHTML;
      button.innerHTML = '<i class="ri-check-line mr-2"></i>Ajouté au panier !';
      button.disabled = true;
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
      }, 2000);
    }
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    const loadImage = async () => {
      const savedImage = await getProductImage(productId);
      if (savedImage) {
        setProductImage(savedImage);
      }
    };
    loadImage();
  }, []);

  const handleImageUpdate = (newImageUrl: string) => {
    setProductImage(newImageUrl || defaultImage);
    setShowImageUploader(false);
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-[#F8EDEA]">
      <Header />
      
      {/* Breadcrumb */}
      <section className="py-4 bg-[#FAF9F8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm">
            <a href="/" className="text-[#B97A72] hover:text-[#6B5E5A] transition-colors" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Accueil
            </a>
            <i className="ri-arrow-right-s-line text-[#6B5E5A]"></i>
            <a href="/boutique" className="text-[#B97A72] hover:text-[#6B5E5A] transition-colors" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Boutique
            </a>
            <i className="ri-arrow-right-s-line text-[#6B5E5A]"></i>
            <span className="text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Lot de 2 Sapins de Noël en livre plié
            </span>
          </nav>
        </div>
      </section>

      {/* Product Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Image du produit */}
            <div>
              <div className="w-full h-[500px] bg-white rounded-lg overflow-hidden shadow-lg mb-4">
                <img
                  src={productImage}
                  alt="Lot de 2 Sapins de Noël en livre plié"
                  className="w-full h-full object-contain"
                />
              </div>
              
              {/* Bouton pour modifier l'image */}
              <div className="text-center">
                <button
                  onClick={() => setShowImageUploader(!showImageUploader)}
                  className="bg-[#B97A72] text-white px-6 py-3 rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  <i className="ri-image-edit-line mr-2"></i>
                  {showImageUploader ? 'Fermer' : '📸 Modifier l\'image'}
                </button>
              </div>

              {/* Module de changement d'image */}
              {showImageUploader && (
                <div className="mt-6 bg-white p-6 rounded-lg shadow-lg">
                  <h3 className="text-xl font-bold text-[#B97A72] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                    Modifier l'image du produit
                  </h3>
                  <LocalImageUploader
                    productId={productId}
                    currentImage={productImage}
                    onImageUpdate={handleImageUpdate}
                  />
                </div>
              )}
            </div>

            {/* Product Info */}
            <div className="space-y-8">
              <div>
                <span className="text-sm text-[#B97A72] font-medium" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Collection de Noël
                </span>
                <h1 className="text-4xl font-bold text-[#6B5E5A] mt-2 mb-4" style={{ fontFamily: 'Allura, cursive' }}>
                  Lot de 2 Sapins de Noël en livre plié – duo poétique 🎁
                </h1>
                
                <div className="bg-[#FAF9F8] border-2 border-[#B97A72] rounded-lg p-6 mb-6">
                  <p className="text-lg text-[#6B5E5A] leading-relaxed italic mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                    <em>Deux petits arbres nés de papier pour illuminer vos fêtes...</em> 🌟
                  </p>
                  <p className="text-[#6B5E5A] leading-relaxed mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Ce duo de sapins en livre plié est entièrement réalisé à la main, à partir de livres recyclés transformés en décorations poétiques.
                  </p>
                  <p className="text-[#6B5E5A] leading-relaxed mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Chaque lot est <strong>unique</strong>, composé de deux sapins assortis mais différents, selon les rubans, dentelles ou papiers disponibles.
                  </p>
                  <p className="text-[#6B5E5A] leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Parfaits pour une décoration de table, une cheminée ou un coin cosy, ils apportent la douceur du fait main à votre Noël 🎄
                  </p>
                </div>
              </div>

              {/* Quantity */}
              <div className="space-y-4">
                <h3 className="text-xl font-semibold text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Quantité :
                </h3>
                <div className="flex items-center space-x-4">
                  <button
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="w-10 h-10 bg-[#EBD2CF] text-[#6B5E5A] rounded-full hover:bg-[#B97A72] hover:text-white transition-colors flex items-center justify-center cursor-pointer"
                  >
                    <i className="ri-subtract-line"></i>
                  </button>
                  <span className="text-xl font-semibold text-[#6B5E5A] w-12 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {quantity}
                  </span>
                  <button
                    onClick={() => setQuantity(quantity + 1)}
                    className="w-10 h-10 bg-[#EBD2CF] text-[#6B5E5A] rounded-full hover:bg-[#B97A72] hover:text-white transition-colors flex items-center justify-center cursor-pointer"
                  >
                    <i className="ri-add-line"></i>
                  </button>
                </div>
              </div>

              {/* Price and Add to Cart */}
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <span className="text-3xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {(product.price * quantity).toFixed(2)}€
                  </span>
                  <span className="text-sm text-green-600 font-medium" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Duo unique !
                  </span>
                </div>
                
                <button
                  onClick={handleAddToCart}
                  className="add-to-cart-btn w-full bg-[#B97A72] text-white px-8 py-4 rounded-full hover:bg-[#C49B86] transition-colors text-lg font-semibold whitespace-nowrap cursor-pointer"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2 inline-block">
                    <i className="ri-shopping-cart-line"></i>
                  </div>
                  Ajouter au panier
                </button>
              </div>

              {/* Product Details */}
              <div className="bg-[#FAF9F8] border-2 border-[#B97A72] rounded-lg p-6 space-y-4">
                <h3 className="text-xl font-semibold text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Caractéristiques :
                </h3>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <i className="ri-ruler-line text-[#B97A72] mr-3 mt-1"></i>
                    <div>
                      <span className="font-medium text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Hauteur :</span>
                      <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>entre 12 et 15 cm</span>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-gift-line text-[#B97A72] mr-3 mt-1"></i>
                    <div>
                      <span className="font-medium text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Contenu :</span>
                      <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>2 sapins assortis (couleurs et finitions variables selon la création)</span>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-leaf-line text-[#B97A72] mr-3 mt-1"></i>
                    <div>
                      <span className="font-medium text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Matières :</span>
                      <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>livres recyclés, rubans, dentelles, fil naturel</span>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-hand-heart-line text-[#B97A72] mr-3 mt-1"></i>
                    <div>
                      <span className="font-medium text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Fabrication :</span>
                      <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>artisanale – chaque lot est unique</span>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-time-line text-[#B97A72] mr-3 mt-1"></i>
                    <div>
                      <span className="font-medium text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Délai :</span>
                      <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>2 à 3 jours ouvrés</span>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-truck-line text-[#B97A72] mr-3 mt-1"></i>
                    <div>
                      <span className="font-medium text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Livraison :</span>
                      <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>Mondial Relay (4,20 € – offerte dès 15 € d'achat)</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Poetic Quote */}
              <div className="text-center py-6">
                <p className="text-xl text-[#B97A72] font-medium italic" style={{ fontFamily: 'Allura, cursive' }}>
                  <em>Deux sapins, deux âmes, un même souffle de lumière.</em> 💫
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Other Products */}
      <section className="py-16 bg-[#EBD2CF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#B97A72] mb-4" style={{ fontFamily: 'Allura, cursive' }}>
              Autres créations de Noël
            </h2>
            <p className="text-lg text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Découvrez toute la magie de la collection
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-[#FAF9F8] rounded-lg border-2 border-[#B97A72] overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Handmade Christmas tree made from folded book pages, centered perfectly on soft pink powder background #F3D9D9, square format 1080x1080px, artisanal paper craft decoration with white lace ribbon and pearl decorations, vintage book pages carefully folded into tree shape, warm natural studio lighting, no shadows, clean minimalist composition, elegant handmade ornament, delicate craftsmanship, product photography style&width=1080&height=1080&seq=sapin-single-related&orientation=squarish"
                  alt="Sapin de Noël en livre plié"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-[#6B5E5A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Sapin de Noël en livre plié 🌟
                </h3>
                <p className="text-[#6B5E5A] text-sm mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Pièce unique faite main
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-2xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>À partir de 14€</span>
                  <a 
                    href="/produit-sapin-noel-livre-plie"
                    className="bg-[#B97A72] text-white px-4 py-2 rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    Voir
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-[#FAF9F8] rounded-lg border-2 border-[#B97A72] overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Handmade paper book candle with white lace ribbon and pearl decorations, folded book pages creating candle shape, centered perfectly on soft pink powder background #F3D9D9, square format 1080x1080px, artisanal Christmas craft, warm natural studio lighting, no shadows, clean minimalist composition, elegant handmade ornament, delicate craftsmanship, product photography style&width=1080&height=1080&seq=bougie-related7&orientation=squarish"
                  alt="Bougie en livre plié"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-[#6B5E5A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Bougie en livre plié
                </h3>
                <p className="text-[#6B5E5A] text-sm mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Quand le papier s'illumine... 🕯️
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-2xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>20 €</span>
                  <a 
                    href="/produit-bougie-livre-plie"
                    className="bg-[#B97A72] text-white px-4 py-2 rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    Voir
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-[#FAF9F8] rounded-lg border-2 border-[#B97A72] overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Small handmade paper angel Christmas decoration made from folded book pages with smiling face, centered perfectly on soft pink powder background #F3D9D9, square format 1080x1080px, artisanal Christmas craft, warm natural studio lighting, no shadows, clean minimalist composition, elegant handmade ornament, delicate craftsmanship, product photography style&width=1080&height=1080&seq=ange-joyeux-related7&orientation=squarish"
                  alt="Ange Joyeux Cœur"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-[#6B5E5A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Ange "Joyeux Cœur"
                </h3>
                <p className="text-[#6B5E5A] text-sm mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Le petit ange au sourire radieux ✨
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-2xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>4€</span>
                  <a 
                    href="/produit-ange-joyeux-coeur"
                    className="bg-[#B97A72] text-white px-4 py-2 rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    Voir
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <a
              href="/boutique"
              className="inline-flex items-center px-8 py-3 bg-[#B97A72] text-white font-semibold rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Voir toute la boutique
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={closeModal}
        >
          <div className="relative max-w-4xl max-h-full">
            <button
              onClick={closeModal}
              className="absolute -top-12 right-0 text-white text-2xl hover:text-gray-300 transition-colors"
            >
              <i className="ri-close-line"></i>
            </button>
            <img
              src={selectedImage}
              alt="Image agrandie"
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
